import { createTheme } from '@material-ui/core/styles';

import { colors } from './colors';

// Customize Theme Here
export const theme = createTheme({
  typography: {
    fontFamily: 'Avenir, Helvetica Neue, Arial, sans-serif',
    body1: {
      fontWeight: 500,
    },
    button: {
      textTransform: 'inherit', // buttons by default have UPPERCASE text. We don't want this.
    },
  },
  palette: {
    primary: {
      main: colors.blue1,
    },
    background: {
      default: '#ffffff',
    },
  },
  props: {
    MuiAppBar: {
      elevation: 0,
    },
  },
  overrides: {
    MuiButton: {
      contained: {
        boxShadow: 'none',
      },
    },
    MuiOutlinedInput: {
      inputMarginDense: {
        paddingTop: 15,
        paddingBottom: 15,
      },
    },
    MuiInputLabel: {
      marginDense: {
        transform: 'translate(14px, 17px) scale(1) !important',
      },
      shrink: {
        transform: 'translate(14px, -6px) scale(0.75) !important',
      },
    },
    MuiTypography: {
      body1: {
        fontSize: 14,
      },
      body2: {
        fontFamily: 'Avenir-Book',
        fontSize: 14,
      },
      h5: {
        fontFamily: 'Avenir-Heavy',
        fontSize: 24,
      },
      h6: {
        fontFamily: 'Avenir-Heavy',
        fontSize: 16.8,
      },
      subtitle2: {
        fontFamily: 'Avenir-Heavy',
        fontSize: 12,
      },
    },
  },
  mhBorderColor: colors.gray1,
  mhBorderWidth: '0.8px',
  bigDot: {
    width: 10,
    height: 10,
  },
});

export const DEFAULT_BOX_SHADOW = '0 6px 10px 0 rgba(179, 193, 210, 0.51)';
